import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { STATUS_ICON } from '@simpl/element-ng/common';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@simpl/element-ng/icon';
import { SiIconModule } from '@simpl/element-ng/icon';
import * as i3 from '@simpl/element-ng/link';
import { SiLinkModule } from '@simpl/element-ng/link';
import * as i4 from '@simpl/element-ng/translate';
import { SiTranslateModule } from '@simpl/element-ng/translate';

class SiInlineNotificationComponent {
    /**
     * Status of inline notification.
     */
    severity;
    /**
     * Heading of the message.
     */
    heading;
    /**
     * Main message of this inline notification.
     */
    message;
    /**
     * Optional link action for inline notification events.
     */
    action;
    /**
     * Params passed to the translation pipe
     */
    translationParams = {};
    /**
     * Displays in embedded style, w/o radius and indicator bar
     */
    embedded = false;
    icon = STATUS_ICON.info;
    ngOnChanges(changes) {
        if (changes.severity && this.severity) {
            this.icon = STATUS_ICON[this.severity];
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiInlineNotificationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiInlineNotificationComponent, selector: "si-inline-notification", inputs: { severity: "severity", heading: "heading", message: "message", action: "action", translationParams: "translationParams", embedded: "embedded" }, usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"alert d-flex align-items-start\"\n  role=\"alert\"\n  aria-atomic=\"true\"\n  aria-live=\"assertive\"\n  [ngClass]=\"'alert-' + severity\"\n  [hidden]=\"!severity\"\n>\n  <si-icon\n    class=\"me-4 flex-shrink-0\"\n    alt=\"\"\n    [icon]=\"icon.icon\"\n    [color]=\"icon.color\"\n    [stackedIcon]=\"icon.stacked\"\n    [stackedColor]=\"icon.stackedColor\"\n  ></si-icon>\n  <div class=\"notification-body d-flex flex-grow-1 flex-wrap mt-1\">\n    <strong *ngIf=\"heading\" class=\"pe-2\">{{ heading | translate : translationParams }}: </strong>\n    <span>{{ message | translate : translationParams }}</span>\n  </div>\n  <a\n    *ngIf=\"action && action.title\"\n    class=\"btn btn-link ms-4 my-n3 me-n2 px-2 flex-shrink-0\"\n    [siLink]=\"action\"\n    >{{ action.title | translate : translationParams }}</a\n  >\n</div>\n", styles: [":host{display:block;overflow:hidden;flex-shrink:0}.btn-link{color:currentColor!important;background:transparent!important;font-size:1rem;line-height:1.25rem}.notification-body{padding-block-start:1px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.SiIconComponent, selector: "si-icon", inputs: ["icon", "color", "stackedIcon", "stackedColor", "alt", "size"] }, { kind: "directive", type: i3.SiLinkDirective, selector: "[siLink]", inputs: ["siLink", "siLinkDefaultTarget", "actionParam", "activeClass", "exactMatch", "ariaCurrent"], outputs: ["activeChange"], exportAs: ["siLink"] }, { kind: "pipe", type: i4.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiInlineNotificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-inline-notification', template: "<div\n  class=\"alert d-flex align-items-start\"\n  role=\"alert\"\n  aria-atomic=\"true\"\n  aria-live=\"assertive\"\n  [ngClass]=\"'alert-' + severity\"\n  [hidden]=\"!severity\"\n>\n  <si-icon\n    class=\"me-4 flex-shrink-0\"\n    alt=\"\"\n    [icon]=\"icon.icon\"\n    [color]=\"icon.color\"\n    [stackedIcon]=\"icon.stacked\"\n    [stackedColor]=\"icon.stackedColor\"\n  ></si-icon>\n  <div class=\"notification-body d-flex flex-grow-1 flex-wrap mt-1\">\n    <strong *ngIf=\"heading\" class=\"pe-2\">{{ heading | translate : translationParams }}: </strong>\n    <span>{{ message | translate : translationParams }}</span>\n  </div>\n  <a\n    *ngIf=\"action && action.title\"\n    class=\"btn btn-link ms-4 my-n3 me-n2 px-2 flex-shrink-0\"\n    [siLink]=\"action\"\n    >{{ action.title | translate : translationParams }}</a\n  >\n</div>\n", styles: [":host{display:block;overflow:hidden;flex-shrink:0}.btn-link{color:currentColor!important;background:transparent!important;font-size:1rem;line-height:1.25rem}.notification-body{padding-block-start:1px}\n"] }]
        }], propDecorators: { severity: [{
                type: Input,
                args: [{ required: true }]
            }], heading: [{
                type: Input
            }], message: [{
                type: Input,
                args: [{ required: true }]
            }], action: [{
                type: Input
            }], translationParams: [{
                type: Input
            }], embedded: [{
                type: Input
            }] } });

class SiInlineNotificationModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiInlineNotificationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiInlineNotificationModule, declarations: [SiInlineNotificationComponent], imports: [CommonModule, SiIconModule, SiLinkModule, SiTranslateModule], exports: [SiInlineNotificationComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiInlineNotificationModule, imports: [CommonModule, SiIconModule, SiLinkModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiInlineNotificationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiIconModule, SiLinkModule, SiTranslateModule],
                    declarations: [SiInlineNotificationComponent],
                    exports: [SiInlineNotificationComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SiInlineNotificationComponent, SiInlineNotificationModule };
